module.exports = __webpack_public_path__ + "static/media/about1.43c6e8fe.jpg";